import React from "react";

export const LexicalEnvContext = React.createContext<{
    uploadUrl: string,
    readUrl: string;
    bearerToken: string;
}>({uploadUrl: "", readUrl: "", bearerToken: ""});